<div class="p-2">
  <button
    [id]="idButton"
    pRipple
    (click)="getClick()"
    class="Btn group w-9 h-9 rounded-full border-none relative overflow-hidden transition-all duration-300 flex items-center justify-start bg-primary-900 shadow-md active:translate-x-[2px] active:translate-y-[2px]"
    [ngClass]="{
      'hover:w-44': base,
      'hover:w-52': !base,
      'bg-primary-900': color == 'primary',
      'bg-secondary-600': color == 'secondary',
      'bg-tertiary-600': color == 'tertiary'
    }"
  >
    <div
      class="sign pointer-events-none w-full text-2xl text-white transition-all duration-300 flex items-center justify-center group-hover:w-[10%] group-hover:pl-[15px]"
    >
      +
    </div>

    <div
      class="text text-nowrap pointer-events-none absolute right-0 w-0 opacity-0 text-white group-hover:opacity-100 group-hover:w-[90%] group-hover:transition-all group-hover:duration-300 group-hover:pr-[15px]"
    >
      {{ text }}
    </div>
  </button>
</div>
